import React, { useCallback, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useConditionalFeature } from '@americanexpress/conditional-features';
import { RenderModule } from 'holocron';
import { Experiment, Variant } from '@americanexpress/one-experiments';
import { setRooms } from '../../ducks/requestDuck';
import { getRooms } from '../../selectors/requestSelectors';
import RoomsTravelerTooltip from './TravelerTooltip';
import HotelsContext from '../../context/hotelsContext';
import { hasDisableTravelerTooltipRule } from '../../constants/featureRulesConstants';
import ThemeContext from '../../context/themeContext';
import { HOMEPAGE_REDESIGN_EXPERIMENT, ROOMS_TRAVELERS_MODULE_NAME } from '../../constants/globalConstants';

const HotelRoomTravelers = () => {
  const theme = useContext(ThemeContext);
  const {
    config: {
      maxAdults,
      maxChildren,
      maxRooms,
      maxTravelersCap,
      maxTravelersPerRoom,
    },
  } = useContext(HotelsContext);
  const hasDisableTravelerTooltip = useConditionalFeature(hasDisableTravelerTooltipRule);
  const value = useSelector(getRooms);
  const dispatch = useDispatch();
  const onChange = useCallback((rooms) => dispatch(setRooms(rooms)), [dispatch]);

  const redesignContent = (
    <RenderModule
      moduleName={ROOMS_TRAVELERS_MODULE_NAME}
      props={{
        id: 'hotels',
        lob: 'hotels',
        theme,
        onChange,
        value,
        maxAdults,
        maxChildren,
        maxRooms,
        maxTravelersCap,
        maxTravelersPerRoom,
      }}
    />
  );

  return (
    <Experiment
      experimentName={HOMEPAGE_REDESIGN_EXPERIMENT}
      dimensionName="search_widget"
      defaultVariant="control"
    >
      <Variant variant="control">
        <div className="pad-0 col-md-6 col-lg-4 col-xl-3 col-xs-12 flex">
          <RenderModule
            moduleName={ROOMS_TRAVELERS_MODULE_NAME}
            props={{
              id: 'hotels',
              theme,
              onChange,
              value,
              maxAdults,
              maxChildren,
              maxRooms,
            }}
          />
          { !hasDisableTravelerTooltip && <RoomsTravelerTooltip /> }
        </div>
      </Variant>
      <Variant variant="widget_a_with_hero">
        {redesignContent}
      </Variant>
      <Variant variant="widget_a_no_hero">
        {redesignContent}
      </Variant>
      <Variant variant="widget_b_with_hero">
        {redesignContent}
      </Variant>
      <Variant variant="widget_b_no_hero">
        {redesignContent}
      </Variant>
    </Experiment>
  );
};

export default HotelRoomTravelers;
